/* eslint-disable no-console */

import {register} from 'register-service-worker'

const applicationServerPublicKey = process.env.VUE_APP_SERVER_PUBLIC_KEY;

function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

function updateSubscriptionOnServer(subscription) {
    if (subscription) {
        const accessToken = localStorage.getItem("token");
        const data = { subscription };
        fetch(process.env.VUE_APP_API_URL + "/notification/add-subscription", {
            method: "POST",
            headers: {
                "authorization": "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log("Success:", data);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
}

function subscribeUser(swRegistration) {
    const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
    swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
    }).then(function (subscription) {
        console.log('User is subscribed.');
        updateSubscriptionOnServer(subscription);
    }).catch(function (error) {
        console.error('Failed to subscribe the user: ', error);
    });
}

function initializeNotification(swRegistration) {
    swRegistration.pushManager.getSubscription().then(function (subscription) {
        const isSubscribed = !(subscription === null);
        if (isSubscribed) {
            console.log('User is subscribed.');
            subscribeUser(swRegistration);
        } else {
            console.log('User is NOT subscribed.');
            subscribeUser(swRegistration);
        }
    });
}

if (process.env.NODE_ENV !== 'development') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready(registration) {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
            initializeNotification(registration);
            registration.active.postMessage({ apiUrl: process.env.VUE_APP_API_URL });
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated() {
            console.log('New content is available; please refresh.')
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })
}
